import { useFlags } from 'launchdarkly-react-client-sdk';
import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';
import { Client } from 'store/clients/clientsSlice';

import NewNoteHeader from './newNoteHeader';
import OldNoteHeader from './noteHeader';

const NoteHeader = ({ note, client }: { note: ClientProfileContentItem; client: Client }) => {
  const { enableBillingUpdates } = useFlags();

  if (enableBillingUpdates) {
    return <NewNoteHeader note={note} client={client} />;
  }
  return <OldNoteHeader note={note} client={client} />;
};

export default NoteHeader;
